module.exports = __webpack_public_path__ + "img/paste.2e92b52b.png";